import { Sector } from './sector.model';
import { Flow } from './flow.model';
import { isNullOrEmpty } from 'app/helper/utils';
import { MachineSetting } from './machine-setting.model';


export class Task {
    id?: string;
    name: number;
    code: number;
    description: string;
    duration: string;
    idPrevious: string;
    timeFromPrevious: string;
    timeFromStart: string;
    urlPlan: string;
    requiredFinished: any[];
    quantity: string;
    labelUrl: string;
    sector: Sector;
    flow: Flow;
    previousTask: Task;
    plans: [];
    configurations: MachineSetting[];

    constructor(task) {
        if (!isNullOrEmpty(task.id)) { this.id = task.id; }
        this.name = task.name;
        this.code = task.code;
        if (!isNullOrEmpty(task.description)) { this.description = task.description; }
        this.duration = task.duration;
        if (!isNullOrEmpty(task.idPrevious)) { this.idPrevious = task.idPrevious; }
        if (!isNullOrEmpty(task.timeFromPrevious)) { this.timeFromPrevious = task.timeFromPrevious; }
        if (!isNullOrEmpty(task.timeFromStart)) { this.timeFromStart = task.timeFromStart; }
        if (!isNullOrEmpty(task.urlPlan)) { this.urlPlan = task.urlPlan; }
        if (!isNullOrEmpty(task.labelUrl)) { this.labelUrl = task.labelUrl; }
        this.quantity = task.quantity;
        if (!isNullOrEmpty(task.sector)) { this.sector = new Sector(task.sector); }
        if (!isNullOrEmpty(task.flow)) { this.flow = new Flow(task.flow); }
        if (!isNullOrEmpty(task.requiredFinished)) { this.requiredFinished = task.requiredFinished; }
        if (!isNullOrEmpty(task.previousTask)) { this.previousTask = new Task(task.previousTask); }
        if (!isNullOrEmpty(task.plans)) { this.plans = task.plans; }
        if (!isNullOrEmpty(task.configurations)) { this.configurations = task.configurations; }
    }

    getRequiredFinishedAsIds(tasks) {
        const temp = [];
        tasks.forEach(t => {
            temp.push(t.task.id);
        });
        return temp;
    }
}

export const TimeTypes = {
    timeFromPrevious: '1',
    timeFromStart: '2',
};
